import Flickity from "flickity";

class TitleImageTabs {
	constructor(config) {
		this.config = Object.assign({
			scope: '.title_image_tabs'
		}, config);

		this.$scope = $(this.config.scope);

		if (this.$scope.length > 0) {
			this.init();
		}
	}

	init() {
		this.$scope.each((index, element) => {
			let $carousel = $(element).find('.main-carousel');
			let carousel = Flickity.data($carousel[0]);
			carousel.on('change', (index) => {
				let $slide = $($carousel.find('.flickity-slide').get(index));
				let color = $slide.data('color');
				let $wrapper = $slide.closest('.background-color');
				let classList = $wrapper[0].classList;
				let classToRemove = '';
				for (let className of classList) {
					let matches = className.match(/text-bg-.*/);
					if (matches) {
						classToRemove = matches[0];
					}
				}
				$wrapper.removeClass(classToRemove);
				$wrapper.addClass(color);
			});
		});
	}
}

export default new TitleImageTabs;